<script lang="ts">
  import { EventTracking } from "@shared/services/event_tracking/events";
  import { getCloudinaryUrl } from "@shared/services/cloudinary_image_url_service";
  import { onDestroy, onMount } from "svelte";

  import type {
    CustomContentSpotlightEntity,
    MiniStoriesContentCardAdEntity,
    MiniStoriesContentCardEntity,
    SpotlightEntity,
    SpotlightAdEntity,
  } from "@shared/services/event_tracking/entities";

  export let imageAltText: string | null;
  export let imageUploadUrl: string | null;
  export let index: number = 0;
  export let objectPrefix: string;
  export let trackingParams: (
    | CustomContentSpotlightEntity
    | SpotlightEntity
    | SpotlightAdEntity
    | MiniStoriesContentCardAdEntity
    | MiniStoriesContentCardEntity
  )[];
  export let useThumbnail: boolean;
  export let videoUploadUrl: string | null;

  const { trackClick } = EventTracking;

  const handleClickToPlay = () => {
    trackClick(`${objectPrefix}_video`, trackingParams);
  };

  let video: any;
  onMount(() => {
    video = document.getElementById(`${objectPrefix}-${index}-video`);
    if (video) {
      video.addEventListener("play", handleClickToPlay);
    }
  });

  onDestroy(() => {
    if (video) {
      video.removeEventListener("play", handleClickToPlay);
    }
  });

  let cloudinaryVideoThumbnail: string;
  let cloudinaryVideoUrl: string;

  if (videoUploadUrl) {
    cloudinaryVideoUrl = getCloudinaryUrl(videoUploadUrl, "c_scale,ar_1.78,h_290/f_auto", "video");

    if (useThumbnail) {
      cloudinaryVideoThumbnail = cloudinaryVideoUrl.replace("mp4", "jpg");
    }
  }
</script>

<div data-testid="image-or-video">
  {#if videoUploadUrl}
    <!-- svelte-ignore a11y-media-has-caption -->
    <video
      id="{objectPrefix}-{index}-video"
      data-testid="{objectPrefix}-{index}-video"
      class="fizz-full-width"
      poster={cloudinaryVideoThumbnail}
      controls
    >
      <source src={cloudinaryVideoUrl} />
    </video>
  {:else}
    <img data-testid="{objectPrefix}-{index}-image" src={imageUploadUrl} alt={imageAltText} />
  {/if}
</div>
